import { StarIconActive } from "app/components/Icons";
import StarIcon from "app/components/Icons/StarIcon";
import CustomTooltip from "app/components/Tooltip";
import React, { useEffect, useState } from "react";

interface StarButtonProps {
  onClick: () => void;
  isFavorite?: boolean;
}
const StarButton: React.FC<StarButtonProps> = ({onClick,isFavorite}) => {
  return (
    <>
    <CustomTooltip text={isFavorite ? 'Unfavourite' : 'Add to favorites'} position="bottom">
        <button
          className="w-[26px] h-[26px] flex items-center justify-center hover:bg-[#E9ECF2] rounded-[1px] p-1 transition-all"
          onClick={onClick}
        >
          {isFavorite === true ? (
            <StarIconActive size={70} />
          ) : (
            <StarIcon size={70} color="#79808A" />
          )}
        </button>
        </CustomTooltip>
    </>
  );
};

export default StarButton;
